import { render } from "./EditBescPricingRulePage.vue?vue&type=template&id=752152a2&ts=true"
import script from "./EditBescPricingRulePage.vue?vue&type=script&lang=ts"
export * from "./EditBescPricingRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__